import { render } from "./Form.vue?vue&type=template&id=a1c005fe&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=a1c005fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a1c005fe"

export default script